// Client-side mirror of app/lib/social_profiles.rb. The server is authoritative;
// these keep the profile forms from posting a URL Rails would reject.

// Vanity slug allows letters, digits, hyphens, underscores, dots, and
// percent-encoded sequences (LinkedIn URL-encodes non-ASCII characters,
// e.g. /in/juli%C3%A1n-p%C3%A9rez).
export const LINKEDIN_PROFILE_URL_REGEX =
  /^https?:\/\/(?:[a-z]{2}\.|www\.)?linkedin\.com\/in\/[A-Za-z0-9._%-]+\/?(?:[?#].*)?$/i;

// X / Twitter handles are 1–15 chars: letters, digits, underscore.
export const X_PROFILE_URL_REGEX =
  /^https?:\/\/(?:www\.|mobile\.)?(?:x\.com|twitter\.com)\/[A-Za-z0-9_]{1,15}\/?(?:[?#].*)?$/i;

export const LINKEDIN_PROFILE_URL_MESSAGE =
  'Must be a valid LinkedIn profile URL in the format: https://linkedin.com/in/username or https://www.linkedin.com/in/username (no trailing slash)';

export const X_PROFILE_URL_MESSAGE =
  'Must be a valid X / Twitter profile URL in the format: https://x.com/username';

export function isValidLinkedInProfileUrl(url: string): boolean {
  return LINKEDIN_PROFILE_URL_REGEX.test(url);
}

export function normalizeLinkedInProfileUrl(input: string): string {
  let url = input.trim();
  if (!url) return url;

  url = url.replace(/[?#].*$/, '');

  url = url.replace(/^http:\/\//i, 'https://');

  if (/^[a-z]{2}\.linkedin\.com\//i.test(url)) {
    url = `https://www.${url.replace(/^[a-z]{2}\./i, '')}`;
  } else if (/^https:\/\/[a-z]{2}\.linkedin\.com\//i.test(url)) {
    url = url.replace(
      /^https:\/\/[a-z]{2}\.linkedin\.com\//i,
      'https://www.linkedin.com/',
    );
  }

  if (/^www\.linkedin\.com\//i.test(url)) {
    url = `https://${url}`;
  } else if (/^linkedin\.com\//i.test(url)) {
    url = `https://www.${url}`;
  }

  url = url.replace(/^https:\/\/linkedin\.com\//i, 'https://www.linkedin.com/');

  url = url.replace(/\/+$/, '');

  return url;
}

export function normalizeXProfileUrl(input: string): string {
  let url = input.trim();
  if (!url) return url;

  url = url.replace(/[?#].*$/, '');
  url = url.replace(/^http:\/\//i, 'https://');

  url = url.replace(
    /^https:\/\/mobile\.(x|twitter)\.com\//i,
    'https://$1.com/',
  );
  url = url.replace(/^https:\/\/www\.(x|twitter)\.com\//i, 'https://$1.com/');

  url = url.replace(/^https:\/\/twitter\.com\//i, 'https://x.com/');

  if (/^(www\.|mobile\.)?(x|twitter)\.com\//i.test(url)) {
    url = `https://${url.replace(/^(www\.|mobile\.)/i, '')}`;
  }

  url = url.replace(/^https:\/\/twitter\.com\//i, 'https://x.com/');

  url = url.replace(/\/+$/, '');

  return url;
}
